import { VirtualService } from '@events/models/virtual-service.interface'

const HANDSHAKE_SERVICE: VirtualService = {
  id: 11,
  title: 'Handshake',
  logo: 'https://res.cloudinary.com/contactless/image/upload/v1636453065/uploaded_public_files/handshake-logo.svg',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/26914669-d6d4-44ed-8747-711774771398.jpeg',
  settings: {},
  website: '',
  informationTemplate: "MICEtribe's own handshake service allows for managed one-to-one attendees encounters and potential lead generation.",
  placeholder: 'https://handshake.micetribe.com',
  active: true,
  slug: 'handshake',
  tutorialVideoId: '',
  has_integration: true,
  addDisplayText: 'Add Service',
  requiresApproval: false,
  coverObjectFit: 'cover'
}

const VFAIRS_VIRTUAL_EVENTS_SERVICE: VirtualService = {
  id: 12,
  title: 'vFairs Virtual Events',
  logo: 'https://library.micetribe.com/workspace/qatarenergy/vfairs-logo-768x324.png',
  settings: {},
  website: '',
  informationTemplate:
    'Host Interactive Virtual Conferences of any size & complexity, manage digital booths, webinars, breakout rooms, immersive 3D environments and robust networking tools.',
  active: false,
  slug: 'vfairs',
  placeholder: '',
  tutorialVideoId: 'FMiGf4Ki0XE',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'vFairs virtual events',
  coverObjectFit: 'cover'
}

const MICROSOFT_TEAMS_SERVICE: VirtualService = {
  id: 4,
  title: 'Microsoft Teams',
  logo: 'https://res.cloudinary.com/contactless/image/upload/v1618918700/uploaded_public_files/ef7llwulrtmsaqq3n3rc.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/57e15efc-8db0-4c68-a4db-288b9b69b817.jpeg',
  website: 'https://teams.microsoft.com',
  regex: /^https?:\/\/(.*\.)?teams\.microsoft\.com.*/,
  settings: {},
  informationTemplate: 'Microsoft Teams is a collaboration app that helps your team stay organized and have conversations—all in one place.',
  active: false,
  slug: 'microsoft-teams',
  placeholder: 'https://teams.microsoft.com/meeting-id',
  tutorialVideoId: '',
  addDisplayText: 'Add Service',
  requiresApproval: false
}

const ZOOM_SERVICE: VirtualService = {
  id: 5,
  title: 'Zoom',
  logo: 'https://res.cloudinary.com/contactless/image/upload/v1618918648/uploaded_public_files/pgqghrzilpti964vyuia.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/4e83ded0-38d8-46ea-a4f4-486f4dfacfa1.jpeg',
  website: 'https://zoom.us',
  regex: /^https?:\/\/(.*\.)?zoom\.us.*/,
  settings: {},
  informationTemplate:
    "Zoom helps businesses and organizations bring their teams together in a smooth environment to boost productivity. It's a reliable cloud platform for video, phone, content sharing, and chat works across mobile devices, desktops, phones, and room systems.",
  active: false,
  slug: 'zoom',
  placeholder: 'https://zoom.us/j/meeting-id',
  addDisplayText: 'Add Service',
  requiresApproval: false,
  tutorialVideoId: ''
}

const CUSTOM_SERVICE: VirtualService = {
  id: 10,
  title: 'Custom Service',
  logo: 'https://res.cloudinary.com/contactless/image/upload/v1619438009/public/video-conferencing-png-make-microsoft-lync-connect-to-any-room-based-video-systems-348.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/5391ea48-5925-418d-bebd-39a2d9a37417.jpeg',
  website: '',
  regex: /^https?:\/\/[a-zA-Z0-9-_.]+\.[a-zA-Z0-9-_.]+/,
  settings: {},
  informationTemplate: "Can't find your favorite app listed? Use this option to add any custom link you need.",
  active: false,
  slug: 'your-own',
  placeholder: 'https://my-meeting-link.com',
  tutorialVideoId: '',
  addDisplayText: 'Add Service',
  requiresApproval: false,
  coverObjectFit: 'cover'
}

/**
 * Location wizard + event-app-card catalog (do not add event-apps-only partners here).
 */
export const VIRTUAL_SERVICES: VirtualService[] = [HANDSHAKE_SERVICE, VFAIRS_VIRTUAL_EVENTS_SERVICE, MICROSOFT_TEAMS_SERVICE, ZOOM_SERVICE, CUSTOM_SERVICE]

const ZAKI_SERVICE: VirtualService = {
  id: 20,
  title: 'Zaki',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/59dab66f-c2a4-4977-9733-c8056e513d3f.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/55f303ad-b16f-49ba-876e-5659d9758fa5.jpeg',
  settings: {},
  website: '',
  description:
    'MICEtribe provides its own AI assistant that connects to your event and allows people to ask questions about your event timing, sessions, speakers, and any public shared information the organizer would like to share.',
  informationTemplate:
    'MICEtribe provides its own AI assistant that connects to your event and allows people to ask questions about your event timing, sessions, speakers, and any public shared information the organizer would like to share.',
  active: false,
  slug: 'zaki',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Zaki'
}

const WALKK_SERVICE: VirtualService = {
  id: 21,
  title: 'Walkk',
  logo: 'https://walkk.ai/walkk-logo.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/55ffbe4b-9cbc-4ca7-9fd7-950d1ee11e03.jpeg',
  settings: {},
  website: 'https://walkk.ai/',
  description: 'Provides your visitors with indoor navigation of your event using interactive maps that highlight exhibitor locations and event services.',
  informationTemplate: 'Provides your visitors with indoor navigation of your event using interactive maps that highlight exhibitor locations and event services.',
  active: false,
  slug: 'walkk',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Walkk'
}

const VFAIRS_MOBILE_APP_SERVICE: VirtualService = {
  id: 22,
  title: 'vFairs Mobile App',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/3ae5981e-ee80-4af2-9ef1-621f78cdad2d.png',
  settings: {},
  website: '',
  description: 'Connect your event mobile app with MICEtribe registration seamlessly. The vFairs app provides the best event app functionalities and usability.',
  informationTemplate: 'Connect your event mobile app with MICEtribe registration seamlessly. The vFairs app provides the best event app functionalities and usability.',
  active: false,
  slug: 'vfairs-mobile-app',
  placeholder: '',
  tutorialVideoId: 'BywL4e4ysM4',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'vFairs Mobile App',
  coverObjectFit: 'cover'
}

const SNOBALL_SERVICE: VirtualService = {
  id: 23,
  title: 'Snöball',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/1ee2c02a-8a0b-4e34-913f-8da2febd7445.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/fdcf2241-def0-47d3-b95e-fd4c5f2c6cbe.jpeg',
  settings: {},
  website: 'https://snoball.events/',
  description: 'Connect your event registration with social media marketing and drive event growth through registrations by making your audience your primary growth engine.',
  informationTemplate:
    'Connect your event registration with social media marketing and drive event growth through registrations by making your audience your primary growth engine.',
  active: false,
  slug: 'snoball',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Add Service',
  requiresApproval: false,
  has_integration: true,
  slackServiceName: 'Snöball'
}

const SWAPCARD_SERVICE: VirtualService = {
  id: 24,
  title: 'SwapCard',
  logo: 'https://image.pngaaa.com/518/6340518-middle.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/f8708aa7-4f39-41b1-ba61-57b32020b9ee.jpg',
  settings: {},
  website: 'https://www.swapcard.com/',
  description:
    'MICEtribe has full integration with SwapCard to push and pull data from MICEtribe to their platform, giving attendees an easy flow for using the SwapCard mobile app.',
  informationTemplate:
    'MICEtribe has full integration with SwapCard to push and pull data from MICEtribe to their platform, giving attendees an easy flow for using the SwapCard mobile app.',
  active: false,
  slug: 'swapcard',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'SwapCard'
}

const TITO_SERVICE: VirtualService = {
  id: 25,
  title: 'Tito',
  logo: 'https://cdn.prod.website-files.com/63751f4948bbc3e724998715/65ca3eacbfd339fe1f1602bf_49f356f2dd2bd61fc8413314dd95c333.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/3ce43faf-8b13-4b90-b611-361309fbc306.jpg',
  settings: {},
  website: 'https://ti.to/home',
  description: 'MICEtribe has integration with Tito to pull data from their platform into the MICEtribe system for a smooth onsite printing and networking experience.',
  informationTemplate: 'MICEtribe has integration with Tito to pull data from their platform into the MICEtribe system for a smooth onsite printing and networking experience.',
  active: false,
  slug: 'tito',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Tito'
}

const VISIT_BY_GES_SERVICE: VirtualService = {
  id: 26,
  title: 'Visit by GES',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/09531743-9364-40d9-9809-e4399600e7b5.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/e52dc441-56e6-4408-bab4-6e0ff9c0f984.jpg',
  // coverImageUrl: 'https://63351b2a.delivery.rocketcdn.me/wp-content/uploads/2022/10/Visit-By-GES-Logo.png',
  settings: {},
  website: 'https://visitcloud.com/',
  description:
    'Pull attendee, exhibitor, and speaker data from GES into MICEtribe with flexible QR code options, unifying onsite operations without disrupting existing workflows.',
  informationTemplate:
    'Pull attendee, exhibitor, and speaker data from GES into MICEtribe with flexible QR code options, unifying onsite operations without disrupting existing workflows.',
  active: false,
  slug: 'visit-by-ges',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Visit by GES'
}

const BRELLA_SERVICE: VirtualService = {
  id: 27,
  title: 'Brella',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/ba794d8c-c839-477b-9a92-42e79bf0ea3a.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/61bb430b-4517-47c1-aa1c-a6cf59a40699.jpg',
  settings: {},
  website: 'https://www.brella.io/',
  description:
    "MICEtribe registration is linked to Brella's B2B networking system, which relies on a powerful recommendation engine that analyzes data points to connect attendees with relevant people.",
  informationTemplate:
    "MICEtribe registration is linked to Brella's B2B networking system, which relies on a powerful recommendation engine that analyzes data points to connect attendees with relevant people.",
  active: false,
  slug: 'brella',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Brella'
}

const CAPTELLO_SERVICE: VirtualService = {
  id: 28,
  title: 'Captello',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/a741a4b3-cf14-4b1f-9d25-3f718850d916.png',
  settings: {},
  website: '',
  description: 'Connect event registration to a gamification tool — reward sign-ups, challenge attendees, and watch engagement soar.',
  informationTemplate: 'Connect event registration to a gamification tool — reward sign-ups, challenge attendees, and watch engagement soar.',
  active: false,
  slug: 'captello',
  placeholder: '',
  tutorialVideoId: 'pOIfNU61QwQ',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Captello',
  coverObjectFit: 'cover'
}

const PIXELS_SERVICE: VirtualService = {
  id: 29,
  title: 'Pixels',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/f5947e9c-c53f-4c53-a6f3-1e7e19efca3c.png',
  coverImageUrl: 'https://miro.medium.com/v2/resize:fit:1400/1*VwkbuUdLKTv2wzly8dFmNg.jpeg',
  settings: {},
  website: '',
  description: 'Connect Meta, Snapchat, TikTok, X, and LinkedIn pixels to your registration page to better monitor your marketing campaigns.',
  informationTemplate: 'Connect Meta, Snapchat, TikTok, X, and LinkedIn pixels to your registration page to better monitor your marketing campaigns.',
  active: false,
  slug: 'pixels',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Pixels',
  coverObjectFit: 'cover'
}

const GOOGLE_TAG_MANAGER_SERVICE: VirtualService = {
  id: 30,
  title: 'Google Tag Manager',
  logo: 'https://iconape.com/wp-content/files/zv/64742/png/google-tag-manager.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/cf3d5ec4-56ff-4d80-b6cc-8e6c6274d083.jpg',
  settings: {},
  website: '',
  description: 'Choose personas of your registration and connect them to Google Tag Manager to report registration metrics.',
  informationTemplate: 'Choose personas of your registration and connect them to Google Tag Manager to report registration metrics.',
  active: false,
  slug: 'google-tag-manager',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Google Tag Manager'
}

const ZAPIER_SERVICE: VirtualService = {
  id: 31,
  title: 'Zapier',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/4bb7434e-e201-4438-b0bc-5889c0e8df41.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/777c0039-afc3-4cf4-b1a6-43c2b2f44992.jpg',
  settings: {},
  website: '',
  description: 'Connect MICEtribe to thousands of apps available on Zapier and create your workflow — request access to our private app.',
  informationTemplate: 'Connect MICEtribe to thousands of apps available on Zapier and create your workflow — request access to our private app.',
  active: false,
  slug: 'zapier',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Zapier'
}

const WICKET_SERVICE: VirtualService = {
  id: 32,
  title: 'Wicket',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/d8ae831a-8851-4227-8618-ad0dce5a5c00.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/2ec4ac0f-d52a-4197-b0cb-7b4a18770e12.jpg',
  settings: {},
  website: 'https://www.wicketsoft.com/',
  description: 'Provide facial recognition for registration so people can check in and print their badges using their faces.',
  informationTemplate: 'Provide facial recognition for registration so people can check in and print their badges using their faces.',
  active: false,
  slug: 'wicket',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Wicket',
  coverObjectFit: 'cover'
}

const EVENT_WEBSITE_SERVICE: VirtualService = {
  id: 33,
  title: 'Event Website',
  logo: 'https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/3ae5981e-ee80-4af2-9ef1-621f78cdad2d.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/f5910cd4-0fa2-4b5d-9386-fc00a43b6269.jpeg',
  settings: {},
  website: 'https://lpshowcase.vfairs.com/',
  description: 'Build a fully custom event website using the vFairs events website builder.',
  informationTemplate: 'Build a fully custom event website using the vFairs events website builder.',
  active: false,
  slug: 'event-website',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Event Website'
}

const AIRMEET_SERVICE: VirtualService = {
  id: 34,
  title: 'Airmeet',
  logo: 'https://cdn.prod.website-files.com/601cf8dbc2fe978600769374/611cb3641c4eda585b85adb3_2_QrCRdiFV2TfTKSoHmlyTHA.png',
  coverImageUrl: 'https://micetribe-staging-storage.s3.eu-west-3.amazonaws.com/shared/064fcc2e-2842-4278-89f6-93f768cba766.jpg',
  settings: {},
  website: 'https://www.airmeet.com/',
  description: 'Create online registration with virtual summits, meetups & workshops with a social lounge to deliver a rich networking experience.',
  informationTemplate: 'Create online registration with virtual summits, meetups & workshops with a social lounge to deliver a rich networking experience.',
  active: false,
  slug: 'airmeet',
  placeholder: '',
  tutorialVideoId: '',
  addDisplayText: 'Request Access',
  requiresApproval: true,
  slackServiceName: 'Airmeet'
}

/**
 * Ordered catalog for the v2 event-apps event-apps modal only.
 */
export const EVENT_APPS_LIST: VirtualService[] = [
  HANDSHAKE_SERVICE,
  ZAKI_SERVICE,
  WALKK_SERVICE,
  VFAIRS_MOBILE_APP_SERVICE,
  SNOBALL_SERVICE,
  SWAPCARD_SERVICE,
  TITO_SERVICE,
  VISIT_BY_GES_SERVICE,
  BRELLA_SERVICE,
  CAPTELLO_SERVICE,
  PIXELS_SERVICE,
  GOOGLE_TAG_MANAGER_SERVICE,
  ZAPIER_SERVICE,
  WICKET_SERVICE,
  EVENT_WEBSITE_SERVICE,
  AIRMEET_SERVICE,
  VFAIRS_VIRTUAL_EVENTS_SERVICE,
  MICROSOFT_TEAMS_SERVICE,
  ZOOM_SERVICE,
  CUSTOM_SERVICE
]
